import { Tools } from "@/utils/utils";
import { Divider, Popover, Row, Space, Tooltip } from "ant-design-vue";
import { computed, defineComponent, ref, watch } from "vue";
import { useStore } from "vuex";
import { ArrowUturnLeftIcon } from "@heroicons/vue/20/solid";
import { fmtMsg } from "vue-glcommonui";
import { ToolboxCanvas } from "@/locales/localeid";
import { Colors, StrokeSizes } from "@/utils/constant";
import { MODULES, vuexName } from "@/store/utils";
export default defineComponent({
  name: "ToolsCanvasComponent",
  emits: ["tool-selected", "update-color", "update-stroke"],
  props: {
    // TODO: Remove unused props
    toolSelected: {
      type: String,
      default: "laser",
    },
    selectorOpen: {
      type: Boolean,
      default: false,
    },
    strokeWidth: {
      type: Number,
      default: 2,
    },
    strokeColor: {
      type: String,
      default: "#000000",
    },
    stickerTool: {
      type: Boolean,
      default: false,
    },
    isPreventDrawOnCanvas: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Row,
    Divider,
    Popover,
    Space,
    ArrowUturnLeftIcon,
    Tooltip,
  },
  setup(props, { emit }) {
    const toolNames: string[] = Object.values(Tools);
    const { getters } = useStore();
    const toolsWithDropdown = [Tools.Stroke, Tools.StrokeColor];
    const toolNameMap = {
      [Tools.Cursor]: "Cursor",
      [Tools.Pen]: "Pen",
      [Tools.Laser]: "Laser Pen",
      [Tools.Stroke]: "Size",
      [Tools.Delete]: "Delete Brush Stroke",
      [Tools.ClearAll]: "Clear Brush Strokes",
      [Tools.StrokeColor]: "Color",
      [Tools.TextBox]: "TextBox",
      [Tools.Line]: "Line",
    };
    const isHelper = computed<boolean>(() => getters[vuexName(MODULES.TEACHER.GETTERS.GET_IS_HELPER)]);
    const showListColors = ref<boolean>(false);
    const showListSize = ref<boolean>(false);
    const colors: any = {};
    //currently the design just have 8 color belows
    const colorsList = Object.values(Colors);
    const strokeSize = Object.values(StrokeSizes).filter((value) => typeof value === "number");
    const handleToolClick = (toolName: string) => {
      emit("tool-selected", toolName);
    };
    const updateColor = (value: string) => {
      emit("update-color", value);
    };
    const updateStrokeSize = (value: number) => {
      emit("update-stroke", value);
    };
    const hideListSize = () => {
      showListSize.value = false;
    };
    const hideListColors = () => {
      showListColors.value = false;
    };

    watch(
      () => props.isPreventDrawOnCanvas,
      (value) => {
        if (value) {
          hideListColors();
          hideListSize();
        }
      },
    );

    const MsgCursor = computed(() => fmtMsg(ToolboxCanvas.Cursor));
    const MsgText = computed(() => fmtMsg(ToolboxCanvas.Text));
    const MsgLaserPen = computed(() => fmtMsg(ToolboxCanvas.LaserPen));
    const MsgPencil = computed(() => fmtMsg(ToolboxCanvas.Pencil));
    const MsgSize = computed(() => fmtMsg(ToolboxCanvas.Size));
    const MsgColor = computed(() => fmtMsg(ToolboxCanvas.Color));
    const MsgCircle = computed(() => fmtMsg(ToolboxCanvas.Circle));
    const MsgSquare = computed(() => fmtMsg(ToolboxCanvas.Square));
    const MsgUndo = computed(() => fmtMsg(ToolboxCanvas.Undo));
    const MsgClear = computed(() => fmtMsg(ToolboxCanvas.Clear));
    const MsgLine = computed(() => fmtMsg(ToolboxCanvas.Line));

    return {
      toolNames,
      toolsWithDropdown,
      toolNameMap,
      colors,
      colorsList,
      handleToolClick,
      updateColor,
      updateStrokeSize,
      strokeSize,
      showListColors,
      showListSize,
      hideListColors,
      hideListSize,
      isHelper,
      MsgCursor,
      MsgText,
      MsgLaserPen,
      MsgPencil,
      MsgSize,
      MsgColor,
      MsgCircle,
      MsgSquare,
      MsgUndo,
      MsgClear,
      MsgLine,
    };
  },
});
